import React, { useEffect} from 'react';
import "../multislider/multislider.css"
import "../mainslider/slider.css";
import "../3dslider/3dslider.css";
import PortaritSlider from "../portraitSlider/portraitSlider";
import "../portraitSlider/portraitSlider.css";
import ImageBanner from "../imageBanner/imageBanner";
import ArticleSlider from "../articleSlider/articleSlider";
import List from "../list/list";
import LandscapeSlider from "../landscapeSlider/landscapeSlider";
import ThreePortaritSlider from "../threeportraitSlider/threeportraitSlider";
import PortraitList from "../portraitList/portraitList";
import LandscapeList from '../landscapeList/landscapeList';
import Grid from '../gridcontainer/grid';
import DoubleGrid from '../gridcontainer/doubleGrid';



const Elements = (props)=>
{
  

 useEffect(()=>{
   

 },[props.inform,props.named])

    if(props.typed==="landscapeSlider")
    {
        return(<div style={{paddingTop:'10px'}} ><LandscapeSlider tabid={props.inform} named={props.named} tabbed={true} header={false}  {...props}></LandscapeSlider></div>);
    }
   
    else if(props.typed==="adBanner")
    {
        return(<div style={{paddingTop:'10px',marginBottom:'10px'}}><ImageBanner tabid={props.inform} tabbed={true} header={false}  {...props}></ImageBanner></div>);
    }
    else if(props.typed==="portraitSlider")
    {
        return(<div style={{paddingTop:'10px'}} ><PortaritSlider tabid={props.inform} named={props.named} tabbed={true} header={false} {...props}></PortaritSlider></div>);
    }
    else if(props.typed==="bigportraitSlider")
    {
        return(<div style={{paddingTop:'20px'}} ><ThreePortaritSlider tabid={props.inform} named={props.named} tabbed={true} header={false} {...props}></ThreePortaritSlider></div>);
    }
    else if(props.typed==="portraitList")
    {
        return(<div style={{paddingTop:'10px'}} ><PortraitList tabid={props.inform} named={props.named} tabbed={true} header={false} {...props}></PortraitList></div>);
    }
    else if(props.typed==="landscapeList")
    {
        return(<div style={{paddingTop:'10px'}} ><LandscapeList tabid={props.inform} named={props.named} tabbed={true} header={false} {...props}></LandscapeList></div>);
    }
    else if(props.typed==="articleSlider")
    {
        return(<div style={{paddingTop:'10px'}} ><ArticleSlider tabid={props.inform} named={props.named} tag={true} tabbed={true} header={false} {...props}></ArticleSlider></div>);
    }
    else if(props.typed==="newsSlider")
    {
        return(<div style={{paddingTop:'10px'}} ><ArticleSlider tabid={props.inform} named={props.named} tag={false} tabbed={true} header={false} {...props}></ArticleSlider></div>);
    }
    else if(props.typed==="newsList")
    {
        return(<div style={{paddingTop:'10px'}} ><List tabid={props.inform} tabbed={true} named={props.named} header={false}  {...props}></List></div>);
    }
    else if(props.typed==="articleList")
    {
        return(<div style={{paddingTop:'10px'}} ><List tabid={props.inform} tabbed={true} named={props.named} header={false}  {...props}></List></div>);
    }
    else if(props.typed==="grid")
    {
        return(<div style={{paddingTop:'10px',}} ><Grid tabid={props.inform} tabbed={true} named={props.named} header={false}  {...props}></Grid></div>);
    }
    else if(props.typed==="doubleGrid")
    {
        return(<div style={{paddingTop:'10px'}} ><DoubleGrid tabid={props.inform} tabbed={true} named={props.named} header={false}  {...props}></DoubleGrid></div>);
    }
   
    else
    {
        return(<div style={{minHeight:'400px'}}></div>);
    }
   

}

export default Elements;